// extracted by mini-css-extract-plugin
module.exports = {"callUs":"callUs_callUs__3gHVB","callUs__message":"callUs_callUs__message__1HLCG","callUs__phone":"callUs_callUs__phone__3UdVO"};